/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { styled, Typography, Button, Radio, DialogContent } from "@mui/material";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const ACCENT_COLOR = '#EA580C'

export const StyledModalTitleContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '5px',
})

export const StyledModalTitle = styled(Typography)({
  fontSize: '20px',
  fontWeight: '600',
})

export const SectionTitle = styled(Typography)({
  fontSize: '13px',
  color: 'gray',
  margin: '20px 0px 10px 0px',
})

export const RecordCard = styled('div')({
  display: 'flex',
  gap: '12px',
  alignItems: 'flex-start',
  border: '1px solid rgba(224, 224, 224, 1)',
  backgroundColor: '#f7f7f7',
  borderRadius: '8px',
  padding: '12px',
})

export const MatchCard = styled('div', {
  shouldForwardProp: (prop) => prop !== 'selected',
})(({ selected }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  border: selected ? `1px solid ${ACCENT_COLOR}` : '1px solid rgba(224, 224, 224, 1)',
  backgroundColor: selected ? '#faf3f1' : '#f7f7f7',
  borderRadius: '8px',
  padding: '12px',
  marginBottom: '12px',
  cursor: 'pointer',
}))

export const StyledMatchRadio = styled(Radio)({
  padding: '0px',
  color: '#d4d3d3',
  '&.Mui-checked': {
    color: ACCENT_COLOR,
  },
})

export const AvatarCircle = styled('div')({
  height: '40px',
  minWidth: '40px',
  borderRadius: '50%',
  backgroundColor: `${ACCENT_COLOR}20`,
  color: ACCENT_COLOR,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: '600',
  fontSize: '14px',
})

export const RecordNameRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flexWrap: 'wrap',
})

export const RecordName = styled(Typography)({
  fontSize: '16px',
  fontWeight: '600',
  marginTop: '-3px',
})

export const RecordSubText = styled(Typography)({
  fontSize: '13px',
  color: 'gray',
  marginTop: '4px',
})

export const MatchDetailText = styled(Typography)({
  fontSize: '13px',
  color: 'gray',
  marginTop: '4px',
})

export const StyledConflictBadge = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: `${ACCENT_COLOR}20`,
  color: ACCENT_COLOR,
  borderRadius: '20px',
  padding: '2px 10px',
  fontSize: '12px',
  fontWeight: '600',
})

export const StyledMergeButton = styled(Button)({
  textTransform: 'none',
  fontSize: '13px',
  backgroundColor: "#395bbd",
  '&:hover': {
    backgroundColor: "#395bbd",
  },
  borderRadius: '8px'
})

export const LoaderContainer = styled(DialogContent)({
  padding: '10px 20px',
  minHeight: "300px",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const ConflictBadge = ({ label }) => (
  <StyledConflictBadge>
    <ReportProblemIcon sx={{ fontSize: '14px' }} />
    {label}
  </StyledConflictBadge>
)
